import moment from 'moment';

// 计划单状态枚举
export const PLAN_STATUS = {
  CREATE: {
    "lookupCode": 10,
    "lookupValue": "创建"
  },
  AUDITING: {
    "lookupCode": 15,
    "lookupValue": "审核中"
  },
  AUDITED: {
    "lookupCode": 20,
    "lookupValue": "已审核"
  },
  RELEASED: {
    "lookupCode": 25,
    "lookupValue": "已发放"
  },
  CANCELLED: {
    "lookupCode": 99,
    "lookupValue": "已作废"
  },
  REMOVED: {
    "lookupCode": 0,
    "lookupValue": "已删除"
  },
  ALL: {
    "lookupCode": -1,
    "lookupValue": "全部"
  }
}

// 备料状态，下拉选项。新增枚举：已下备料单/备料中/备料完成
export const MATERIAL_STATUS = {
  MADE_UP: {
    value: 1,
    label: "已下备料单"
  },
  IN_PROGRESS: {
    value: 2,
    label: "备料中"
  },
  COMPLETED: {
    value: 3,
    label: "备料完成"
  }
}

export const MATERIAL_STATUS_NAME_MAP = Object.values(MATERIAL_STATUS).reduce((prev, cur) => {
  prev[cur.value] = cur.label
  return prev
}, {})

// 单据类型 todo
export const DOCUMENT_TYPE = {
  MONTHLY_PURCHASE: {
    label: '月度采购计划',
    value: 'MONTHLY_PURCHASE'
  },
  AGENCY_STOCKING: {
    label: '代发备货计划',
    value: 'AGENCY_STOCKING'
  },
  SPECIAL_GOODS: {
    label: '专货',
    value: 'SPECIAL_GOODS'
  }
}

// 签署状态
export const SIGN_STATUS = {
  NOT_SIGNED: {
    label: '未签署',
    value: 'NOT_SIGNED'
  },
  // PENDING_LINSHI: {
  //   label: '待林氏签署',
  //   value: 'PENDING_LINSY_SIGN'
  // },
  PENDING_SUPPLIER: {
    label: '待供应商签署',
    value: 'PENDING_SUPPLIER_SIGN'
  },
  SIGNED: {
    label: '已签署',
    value: 'SIGNED'
  },
  SIGN_FAILED: {
    label: '签署失败',
    value: 'SIGN_FAILED'
  }
}

export function formatDate (date) {
  if(date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
  }
  return '';
}

export function formatDateOnly (date) {
  if(date) {
    return moment(date).format('YYYY-MM-DD')
  }
  return '';
}
export const PLAN_POOL_STATUS_NAME_MAP = Object.values(PLAN_STATUS).reduce((prev, cur) => {
  prev[cur.lookupCode] = cur.lookupValue
  return prev
}, {})
export const SIGN_STATUS_NAME_MAP = Object.values(SIGN_STATUS).reduce((prev, cur) => {
  prev[cur.value] = cur.label
  return prev
}, {})
// 采购计划单列表字段配置
export const MONTH_PLAN_POOL_COLUMNS = [
  {
    title: "序号",
    dataIndex: "index",
    width: 60,
    customRender: (text, record, index) => index + 1
  },
  {
    title: "计划单号",
    dataIndex: "planNo",
    sorter: true,
    width: 130
  },
  {
    title: "计划单行ID",
    dataIndex: "planLineId",
    width: 90
  },
  {
    title: "单据状态",
    dataIndex: "statusName",
    width: 80
  },
  {
    title: "单据类型",
    dataIndex: "typeName",
    width: 90
  },
  {
    title: "申请人",
    dataIndex: "applicantUserName",
    width: 90
  },
  {
    title: "供应商",
    dataIndex: "supplierName",
    width: 150,
    scopedSlots: { customRender: 'supplierName' }
  },
  {
    title: "物料编码",
    dataIndex: "itemCode",
    width: 120
  },
  {
    title: "物料名称",
    dataIndex: "itemName",
    width: 150,
    scopedSlots: { customRender: 'textEllipsis' }
  },
  {
    title: "规格描述",
    dataIndex: "specification",
    width: 150,
    scopedSlots: { customRender: 'textEllipsis' }
  },
  {
    title: "工艺大类",
    dataIndex: "productBroadCategoryName",
    width: 120
  },
  {
    title: "材质",
    dataIndex: "material",
    width: 90
  },
  {
    title: "是否供应商新品",
    dataIndex: "isSupplierNewProductName",
    width: 90
  },
  {
    title: "项目部",
    dataIndex: "projectDept",
    width: 90
  },
  {
    title: "计划数量",
    dataIndex: "planQuantity",
    width: 90,
    scopedSlots: { customRender: 'planQuantity' }
  },
  {
    title: "计划周期",
    dataIndex: "planCycle",
    width: 90,
    scopedSlots: { customRender: 'planCycle' }
  },
  {
    title: "含税单价",
    dataIndex: "taxUnitPrice",
    width: 90
  },
  {
    title: "计划采购金额",
    dataIndex: "planAmount",
    width: 90
  },
  {
    title: "计划下发空闲数",
    dataIndex: "planFreeQuantity",
    width: 100
  },
  {
    title: "签价单号",
    dataIndex: "alternateBomDesignator",
    width: 120
  },
  {
    title: "备料需求完成时间",
    dataIndex: "reqFinishDate",
    width: 100,
    scopedSlots: { customRender: 'formatDateOnly' }
  },
  {
    title: "备料完成时间",
    dataIndex: "actualFinishDate",
    width: 100,
    scopedSlots: { customRender: 'formatDateOnly' }
  },
  {
    title: "备料状态",
    dataIndex: "materialStatus",
    scopedSlots: { customRender: 'materialStatus' },
    width: 90
  },
  {
    title: "预计交货时间",
    dataIndex: "estimatedDeliveryDate",
    width: 100,
    scopedSlots: { customRender: 'formatDateOnly' }
  },
  {
    title: "最快交期",
    dataIndex: "fastestDeliveryDate",
    width: 100,
    scopedSlots: { customRender: 'formatDateOnly' }
  },
  {
    title: "签署状态",
    dataIndex: "signStatus",
    scopedSlots: { customRender: 'signStatus' },
    width: 90
  },
  {
    title: "采购空闲数",
    dataIndex: "purchaseFreeQuantity",
    width: 90
  },
  {
    title: "已推采购",
    dataIndex: "pushedPurchaseQuantity",
    width: 90
  },
  {
    title: "计划单签署数量",
    dataIndex: "signedQuantity",
    width: 90
  },
  {
    title: "包件BOM版本",
    dataIndex: "packageBomVersionCode",
    width: 90
  },
  {
    title: "采购订单签署数量",
    dataIndex: "purchaseSignedQuantity",
    width: 90
  },
  {
    title: "采购主体",
    dataIndex: "purchaseOrgCodeName",
    width: 100
  },
  {
    title: "创建人",
    dataIndex: "createName",
    width: 100
  },
  {
    title: "创建日期",
    dataIndex: "createTime",
    width: 100,
    scopedSlots: { customRender: 'formatDateOnly' }
  },
  {
    title: "审核日期",
    dataIndex: "auditTime",
    width: 100,
    scopedSlots: { customRender: 'formatDateOnly' }
  },
  {
    title: "发放日期",
    dataIndex: "issueTime",
    width: 100,
    scopedSlots: { customRender: 'formatDateOnly' }
  },
  {
    title: "林氏备注",
    dataIndex: "companyRemark",
    width: 150,
    scopedSlots: { customRender: 'companyRemark' }
  },
  {
    title: "供应商备注",
    dataIndex: "supplierRemark",
    width: 150,
    scopedSlots: { customRender: 'textEllipsis' }
  },
  {
    title: '行ID',
    dataIndex: "id",
    width: 120
  },
  {
    title: '变更记录',
    dataIndex: "changeRecord",
    scopedSlots: { customRender: 'changeRecord' },
    width: 100
  },
  {
    title: '研发分类标识',
    dataIndex: "developType",
    width: 120
  },
  {
    title: "操作",
    dataIndex: "operation",
    width: 150,
    stickyFixed: 'right',
    scopedSlots: { customRender: 'operation' }
  }
];

export function positiveNumValidate(rule, value, callbackFunc) {
  if(value === undefined || value === '' || value === null) {
    callbackFunc('不能为空');
  } else if(value < 0) {
    callbackFunc('不可等于0')
  }else {
    callbackFunc()
  }
}

// 林氏主动
export const LS_INITIATIVE_COLUMNS = [
  {
    title: '序号',
    width: 60,
    dataIndex: "reportIndex",
    customRender: (text, record, index) => {
      return index + 1;
    },
    stickyFixed: 'left'
  },
  { title: '物料编码', dataIndex: 'itemCode', width: 140 },
  { title: '物料名称', dataIndex: 'itemName', width: 150 },
  { title: '规格描述', dataIndex: 'specification', width: 160, ellipsis: true },
  { title: '原数量', dataIndex: 'originalQuantity', width: 80 },
  {
    title: '变更数量',
    dataIndex: 'changeQuantity',
    scopedSlots: { customRender: 'changeQuantity' },
    width: 120
  },
  {
    title: '变更类型',
    dataIndex: 'changeType',
    scopedSlots: { customRender: 'changeType' },
    width: 120
  },
  {
    title: '原定交期',
    dataIndex: 'originalPlanCycle',
    width: 120
  },
  {
    title: '变更交期',
    dataIndex: 'changePlanCycle',
    scopedSlots: { customRender: 'changePlanCycle' },
    width: 140
  },
  {
    title: '是否考核',
    dataIndex: 'assessorIs',
    scopedSlots: { customRender: 'assessorIs' },
    width: 100
  },
  {
    title: '责任方',
    dataIndex: 'responsibleParty',
    scopedSlots: { customRender: 'responsibleParty' },
    width: 120
  },
  {
    title: '考核方',
    dataIndex: 'assessor',
    scopedSlots: { customRender: 'assessor' },
    width: 160
  },
  {
    title: '变更原因',
    dataIndex: 'changeReason',
    scopedSlots: { customRender: 'changeReason' },
    width: 180
  },
  {
    title: '行类型',
    dataIndex: 'lineType',
    width: 80
  }
]

// 林氏主动-价格变更
export const INITIATIVE_PRICE_CHANGE_COLUMNS = [
  {
    title: '序号',
    width: 60,
    dataIndex: "reportIndex",
    customRender: (text, record, index) => {
      return index + 1;
    },
    stickyFixed: 'left'
  },
  { title: '物料编码', dataIndex: 'itemCode', width: 140 },
  { title: '物料名称', dataIndex: 'itemName', width: 150 },
  { title: '规格描述', dataIndex: 'specification', width: 160, ellipsis: true },
  { title: '原数量', dataIndex: 'originalQuantity', width: 80 },
  {
    title: '变更数量',
    dataIndex: 'changeQuantity',
    scopedSlots: { customRender: 'changeQuantity' },
    width: 120
  },
  {
    title: '变更类型',
    dataIndex: 'changeType',
    scopedSlots: { customRender: 'changeType' },
    width: 120
  },
  {
    title: '执行日期',
    dataIndex: 'pricingDate',
    scopedSlots: { customRender: 'pricingDate' },
    width: 140
  },
  { title: '签价仓库', dataIndex: 'warehouseName', width: 100 },
  { title: '原价格', dataIndex: 'originalPrice', width: 90 },
  { title: '变更价格', dataIndex: 'changePrice', width: 100 },
  { title: '原档位', dataIndex: 'originalTriggerLevel', width: 90 },
  { title: '原取价档位',
    dataIndex: 'originalQuoteGradePlace',
    width: 100,
    customRender: (text, record) => {
      return record.originalTriggerLevel;
    }
  },
  { title: '变更档位', dataIndex: 'actualTriggerLevel', width: 100 },
  {
    title: '是否考核',
    dataIndex: 'assessorIs',
    scopedSlots: { customRender: 'assessorIs' },
    width: 100
  },
  {
    title: '责任方',
    dataIndex: 'responsibleParty',
    scopedSlots: { customRender: 'responsibleParty' },
    width: 120
  },
  {
    title: '考核方',
    dataIndex: 'assessor',
    scopedSlots: { customRender: 'assessor' },
    width: 160
  },
  {
    title: '变更原因',
    dataIndex: 'changeReason',
    scopedSlots: { customRender: 'changeReason' },
    width: 180
  },
  {
    title: '行类型',
    dataIndex: 'lineType',
    width: 80
  }
]

// 责任方枚举
// export const RESPONSIBLEPARTY_ENUM = [
//   { label: '林氏', value: 10 },
//   { label: '成品供应商', value: 11 },
//   { label: '零部件供应商', value: 12 },
//   { label: '材料供应商', value: 13 }
// ]

// 变更类型枚举
export const CHANGE_TYPE_ENUM = {
  DELIVERY_DATE_CHANGE: { value: 10, label: '交期变更' },
  // DELIVERY_DELAY: { value: 11, label: '交期延期' },
  CANCEL_SUPPLY: { value: 12, label: '取消供货' },
  PRICE_CHANGE: { value: 13, label: '价格变更' },
  BOM_VERSION_CHANGE: { value: 14, label: '变更BOM版本' },
  CUSTOMS_INFO_CHANGE: { value: 15, label: '报关信息变更' }
}

export const INITIATION_TYPE_ENUM = {
  LS_INITIATIVE: { value: '10', label: '林氏主动' },
  LS_INITIATIVE_PRICE_CHANGE: { value: '11', label: '林氏主动-价格变更' }
}
